module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [(_vm.showCookieWarning) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 mt-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-center card cookie p-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.acceptCookies
    }
  }, [_vm._v("Got It")])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-5",
    attrs: {
      "id": "login-component"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.hasFailed) ? _c('el-alert', {
    attrs: {
      "title": "Login Failed",
      "type": "error",
      "description": "Sorry, your email address or password is incorrect"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginFormRules
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onClickLogin($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isPending,
      "placeholder": "Email"
    },
    model: {
      value: (_vm.loginForm.email),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "email", $$v)
      },
      expression: "loginForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isPending,
      "placeholder": "Password",
      "type": "password"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "login-btn",
      "type": "primary",
      "loading": _vm.isPending
    },
    on: {
      "click": _vm.onClickLogin
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('router-link', {
    staticClass: "text-light-grey",
    attrs: {
      "to": {
        name: 'PasswordReset'
      }
    }
  }, [_vm._v("Forgot Password?")])], 1)], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-row align-items-center"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/cookie.png",
      "width": "40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-2 mr-2"
  }, [_c('span', [_vm._v("We use third party cookies to personalize content and analyze site traffic. By using this website, you automatically accept that we use cookies")]), _c('a', {
    staticClass: "learn-more",
    attrs: {
      "href": "https://colonylive.b-cdn.net/wp-content/uploads/2021/03/COLONYLive-web-Privacy-policy.pdf"
    }
  }, [_vm._v(" Learn more"), _c('i', {
    staticClass: "fa fa-angle-right ml-2"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-purple"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logos/logo-white-live.svg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "page-icon",
    attrs: {
      "src": "static/assets/icons/auth/lock.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey text-white text-center welcome-text"
  }, [_c('h4', [_vm._v("A warm welcome to you")]), _vm._v(" "), _c('p', [_vm._v("Login and feel free to leave us your feedback.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f701a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/auth/LoginForm.vue
// module id = 3315
// module chunks = 3